import clsx from "clsx";

import { FCCC } from "@/types";

/** Target id for the portal skip link (`layout.skipToContent`). */
export const MAIN_CONTENT_ID = "main-content";

/** The page's main landmark in both shells (portal and pre-login). */
export const ContentContainer: FCCC = ({ children, className }) => (
  <main
    id={MAIN_CONTENT_ID}
    className={clsx(
      "grid-container p-4 outline-none tablet:p-6 desktop:p-8",
      className,
    )}
    tabIndex={-1}
  >
    <div className="grid grid-cols-grid gap-x-gutter">{children}</div>
  </main>
);
